import { render, staticRenderFns } from "./FeedStockList.vue?vue&type=template&id=bb2da284&scoped=true&"
import script from "./FeedStockList.vue?vue&type=script&lang=js&"
export * from "./FeedStockList.vue?vue&type=script&lang=js&"
import style1 from "./FeedStockList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2da284",
  null
  
)

export default component.exports